import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import './index.scss';
import { bool } from 'prop-types';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { number } from 'prop-types';
import { AuthContext } from '../../Contexts';

const Loyalty = ({ amount, isFromDrug }) => {
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const firstName = userData?.firstName;
  const { t, i18n } = useTranslation();
  return (
    isLoggedIn &&
    amount > 1.0 && (
      <div className="LoyaltyContainer">
        <div className="LoyaltyContent">
          {isFromDrug ? (
            <p>
              <span>
                ${Number(amount).toFixed(2)}&nbsp;
                {_.isEqual(i18n.language, 'es')
                  ? `${t('in bonus savings')}`
                  : `bonus savings`}
                &nbsp;
              </span>
              {t('applies to any eligible offer below')}
            </p>
          ) : (
            <div>
              <p className="hideOnPhone desktop-only">
                {t('Hi')},&nbsp;{firstName}! {t('You have')}{' '}
                <span>${Number(amount).toFixed(2)}</span>{' '}
                {t('in bonus savings')}
                {t('available.')}
              </p>
              <p className="showOnPhone mobile-only">
                {t('Hi')}! {t('You have')}{' '}
                <span>${Number(amount).toFixed(2)}</span> {t('in')}
                &nbsp;
                {t('Bonus savings')}
              </p>
            </div>
          )}
        </div>
      </div>
    )
  );
};
Loyalty.defaultProps = {
  amount: 0,
  isFromDrug: false
};
Loyalty.propTypes = {
  amount: number,
  isFromDrug: bool
};

export default withRouter(Loyalty);
